import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/images/icon_checklist_line_plus.png'


const _hoisted_1 = { class: "pantry-list-item" }
const _hoisted_2 = {
  key: 0,
  class: "pantry-list-item-empty"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pantry-list-item-summry-name-text" }, "未登録", -1)
const _hoisted_4 = {
  key: 1,
  class: "pantry-list-item-area"
}
const _hoisted_5 = { class: "pantry-list-item-check-view" }
const _hoisted_6 = { class: "pantry-list-item-button-area" }
const _hoisted_7 = { class: "pantry-list-item-virtual-area" }
const _hoisted_8 = { class: "pantry-list-item-summry-area" }
const _hoisted_9 = { class: "pantry-list-item-summry-image" }
const _hoisted_10 = { class: "pantry-list-item-summry-name" }
const _hoisted_11 = { class: "pantry-list-item-summry-name-text" }
const _hoisted_12 = {
  key: 0,
  class: "pantry-list-item-summry-date"
}
const _hoisted_13 = { class: "pantry-list-item-summry-date-area" }
const _hoisted_14 = { class: "pantry-list-item-summry-date-view" }
const _hoisted_15 = { class: "pantry-list-item-summry-start-date-text b" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "pantry-list-item-summry-date-view" }, [
  /*#__PURE__*/_createVNode("div", { class: "pantry-list-item-summry-date-text" }, "-")
], -1)
const _hoisted_17 = { class: "pantry-list-item-summry-date-view" }
const _hoisted_18 = { class: "pantry-list-item-summry-end-date-text" }
const _hoisted_19 = {
  key: 1,
  class: "pantry-list-item-plate-error"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", {
  class: "pantry-list-item-plate-error-text",
  innerHTML: '重量検知プレートが</br>正常動作してません'
}, null, -1)
const _hoisted_21 = { class: "pantry-list-item-setting-area" }
const _hoisted_22 = {
  key: 0,
  class: "pantry-list-item-range-view"
}
const _hoisted_23 = { class: "pantry-list-item-value-view" }
const _hoisted_24 = { class: "pantry-list-item-value-text" }
const _hoisted_25 = { class: "pantry-list-item-unit-text" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "pantry-list-item-range-background" }, null, -1)
const _hoisted_27 = {
  key: 1,
  class: "pantry-list-item-range-empty-view"
}
const _hoisted_28 = { class: "pantry-list-item-setting-image-area" }
const _hoisted_29 = {
  key: 1,
  class: "pantry-list-item-setting-image-view"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  class: "pantry-list-item-setting-image",
  src: _imports_0
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isPlateEmpty())
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _withDirectives(_createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("button", {
                class: "pantry-list-item-button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickCheck(...args)))
              }, [
                _createVNode("img", {
                  class: "pantry-list-item-check-image",
                  src: _ctx.checkedImage
                }, null, 8, ["src"])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isSelectMode()]
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("div", {
                class: "pantry-list-item-click-area",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickFood(...args)))
              }, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("img", {
                    class: "pantry-list-item-summry-image-icon",
                    src: _ctx.getImage(),
                    onError: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
                  }, null, 40, ["src"])
                ]),
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.getName()), 1)
                ])
              ]),
              (!_ctx.isShowPlateError())
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("div", _hoisted_14, [
                        _createVNode("div", _hoisted_15, _toDisplayString(_ctx.getPurchaseDate()), 1)
                      ]),
                      _hoisted_16,
                      _createVNode("div", _hoisted_17, [
                        _createVNode("div", _hoisted_18, _toDisplayString(_ctx.getExpirationDate()), 1)
                      ])
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_19, [
                    _hoisted_20
                  ]))
            ]),
            _createVNode("div", _hoisted_21, [
              (_ctx.isShowRange())
                ? (_openBlock(), _createBlock("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, _toDisplayString(_ctx.getRangeValue()), 1),
                      _createVNode("div", _hoisted_25, _toDisplayString(_ctx.getRangeUnit()), 1)
                    ]),
                    _hoisted_26,
                    (_ctx.isShowRangeThumb())
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          class: "pantry-list-item-input-range",
                          type: "range",
                          name: "speed",
                          min: "0",
                          max: "100",
                          step: "10",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue = $event)),
                          style: _ctx.styleRange,
                          onTouchend: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onTouchEndEvent(...args)))
                        }, null, 36)), [
                          [_vModelText, _ctx.modelValue]
                        ])
                      : _withDirectives((_openBlock(), _createBlock("input", {
                          key: 1,
                          class: "pantry-list-item-input-range",
                          type: "range",
                          name: "rate",
                          min: "0",
                          max: "100",
                          step: "10",
                          disabled: "",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue = $event)),
                          style: _ctx.styleRange
                        }, null, 4)), [
                          [_vModelText, _ctx.modelValue]
                        ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_27)),
              _withDirectives(_createVNode("div", _hoisted_28, [
                (_ctx.isShowFavorite())
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "pantry-list-item-setting-image-view",
                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clickFavortite(...args)))
                    }, [
                      _createVNode("img", {
                        class: "pantry-list-item-setting-image-favorite",
                        src: _ctx.favoriteImage
                      }, null, 8, ["src"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_29)),
                _createVNode("div", {
                  class: "pantry-list-item-setting-image-view",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clickShoplist(...args)))
                }, [
                  _hoisted_30
                ])
              ], 512), [
                [_vShow, _ctx.isShowImage()]
              ])
            ])
          ])
        ]))
  ]))
}